import { render, staticRenderFns } from "./ClientPayment.vue?vue&type=template&id=491d5d50&scoped=true&"
import script from "./ClientPayment.vue?vue&type=script&lang=js&"
export * from "./ClientPayment.vue?vue&type=script&lang=js&"
import style0 from "./ClientPayment.vue?vue&type=style&index=0&id=491d5d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d5d50",
  null
  
)

export default component.exports